module.exports = __webpack_public_path__ + "static/media/sg_1.48862c9c.ogg";